module.exports = __webpack_public_path__ + "static/img/press11.880b2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press11.png
// module id = zXCJ
// module chunks = 0